// src/pages/MentalPlus/IslandRegistry.tsx
import { motion } from "framer-motion";
import type { ComponentType } from "react";

// ---- SVG Imports AS URLS ----
// (important for performance + re-use in D3 charts)
import moiNeutreUrl from "../../assets/MentalPlus/MOI/neutral.png?url";
import moiNuitUrl from "../../assets/MentalPlus/MOI/sleep.png?url";
import moiSoleilUrl from "../../assets/MentalPlus/MOI/verygood.png?url";
import moiNuageUrl from "../../assets/MentalPlus/MOI/good.png?url";
import moiCouvertUrl from "../../assets/MentalPlus/MOI/neutral.png?url";
import moiPluieUrl from "../../assets/MentalPlus/MOI/sad.png?url";
import moiOrageUrl from "../../assets/MentalPlus/MOI/crying.png?url";

// ------- AMIS -------
import AmisNeutreUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Neutre.png?url";
import AmisNuitUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Nuit.svg?url";
import AmisSoleilUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Soleil.svg?url";
import AmisNuageUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Nuage.svg?url";
import AmisCouvertUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Couvert.svg?url";
import AmisPluieUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Pluie.svg?url";
import AmisOrageUrl from "../../assets/MentalPlus/AMIS/ILES-AVEC-METEO_AMIS_Orage.svg?url";

// ------- AMOUR -------
import AmourNeutreUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Neutre.png?url";
import AmourNuitUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Nuit.svg?url";
import AmourSoleilUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Soleil.svg?url";
import AmourNuageUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Nuage.svg?url";
import AmourCouvertUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Couvert.svg?url";
import AmourPluieUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Pluie.svg?url";
import AmourOrageUrl from "../../assets/MentalPlus/AMOUR/ILES-AVEC-METEO_AMOUR_Orage.svg?url";

// ------- ECRANS -------
import EcransNeutreUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Neutre.png?url";
import EcransNuitUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Nuit.svg?url";
import EcransSoleilUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Soleil.svg?url";
import EcransNuageUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Nuage.svg?url";
import EcransCouvertUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Couvert.svg?url";
import EcransPluieUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Pluie.svg?url";
import EcransOrageUrl from "../../assets/MentalPlus/ECRANS/ILES-AVEC-METEO_ECRANS_Orage.svg?url";

// ------- ETUDES (not yet used in registry but ready) -------
import EtudesNeutreUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Neutre.png?url";
import EtudesNuitUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Nuit.svg?url";
import EtudesSoleilUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Soleil.svg?url";
import EtudesNuageUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Nuage.svg?url";
import EtudesCouvertUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Couvert.svg?url";
import EtudesPluieUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Pluie.svg?url";
import EtudesOrageUrl from "../../assets/MentalPlus/ETUDES/ILES-AVEC-METEO_ETUDES_Orage.svg?url";

// ------- FAMILLE -------
import FamilleNeutreUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Neutre.png?url";
import FamilleNuitUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Nuit.svg?url";
import FamilleSoleilUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Soleil.svg?url";
import FamilleNuageUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Nuage.svg?url";
import FamilleCouvertUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Couvert.svg?url";
import FamillePluieUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Pluie.svg?url";
import FamilleOrageUrl from "../../assets/MentalPlus/FAMILLE/ILES-AVEC-METEO_FAMILLE_Orage.svg?url";

// ------- LOISIRS -------
import LoisirsNeutreUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Neutre.svg?url";
import LoisirsNuitUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Nuit.svg?url";
import LoisirsSoleilUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Soleil.svg?url";
import LoisirsNuageUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Nuage.svg?url";
import LoisirsCouvertUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Couvert.svg?url";
import LoisirsPluieUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Pluie.svg?url";
import LoisirsOrageUrl from "../../assets/MentalPlus/LOISIRS/ILES-AVEC-METEO_LOISIRS_Orage.svg?url";


// ------- LOISIRS -------
import WeatherSoleilUrl from "../../assets/MentalPlus/WEATHER/ILLU-METEO_SOLEIL.png?url";
import WeatherCouvertUrl from "../../assets/MentalPlus/WEATHER/ILLU-METEO_COUVERT.png?url";
import WeatherNuageUrl from "../../assets/MentalPlus/WEATHER/ILLU-METEO_NUAGE.png?url";
import WeatherPluieUrl from "../../assets/MentalPlus/WEATHER/ILLU-METEO_PLUIE.png?url";
import WeatherOrageUrl from "../../assets/MentalPlus/WEATHER/ILLU-METEO_ORAGE.png?url";
// ----------------------------------------------------
// Weather keys & scale types
// ----------------------------------------------------

export type WeatherKey =
  | "neutre"
  | "nuit"
  | "soleil"
  | "couvert"
  | "nuage"
  | "pluie"
  | "orage";

export type ScaleOutputMode = "emoji" | "sprite";

export interface ScaleDef {
  min: number;
  max: number;
  mode: ScaleOutputMode;
  /**
   * - if mode === "emoji": returns an emoji (e.g. "🙂")
   * - if mode === "sprite": returns a sprite key (e.g. "soleil", "orage", "low", "high"...)
   */
  map: (score: number) => string;
}

export interface SequenceVisualConfig {
  sequenceId?: number;
  chartType?: "circles" | "emojis" | "sprites";
  scale?: ScaleDef;
  islandScale?: ScaleDef;
}

export interface IslandDef {
  key: string;
  title: string;

  // main questionnaire (non-inline)
  main: SequenceVisualConfig;

  // inline questionnaire
  inline?: SequenceVisualConfig;

  // which sequence’s scale is used to pick the icon sprite
  iconFromInline?: boolean;

  // base/night icon component (wrapped from url)
  NightComponent: ComponentType<any>;
  NeutralComponent: ComponentType<any>;
  dx?: number;
  dy?: number;
  subs?: IslandDef[];
  iconWidth?: number | string;

  // sprite set for this island – your “weather” svgs as React components
  weatherSprites?: Partial<Record<WeatherKey, ComponentType<any>>>;

  // raw URLs for those sprites, reused in EvolutionChart
  spriteUrls?: Partial<Record<WeatherKey, string>>;

  // GRAPH PAGE sprites (optional override)
  // - if undefined => graph uses spriteUrls
  // - if set => graph uses this instead (can be the shared one)
  graphSpriteUrls?: Partial<Record<WeatherKey, string>>;
}

// ----------------------------------------------------
// Helpers: wrap URL → motion.div + combined sprite sets
// ----------------------------------------------------

// Given a URL, return a motion.div that uses it as background-image
function wrapFromUrl(url: string): ComponentType<any> {
  const Wrapped: ComponentType<any> = (props: any) => (
    <motion.div
      {...props}
      style={{
        ...(props.style ?? {}),
        backgroundImage: `url("${url}")`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
  );
  return Wrapped;
}

// Takes a mapping (WeatherKey -> url) and returns both:
// - weatherSprites: WeatherKey -> wrapped component
// - spriteUrls: WeatherKey -> raw url (for D3 charts)
function makeSpriteSet(urls: Record<WeatherKey, string>) {
  const weatherSprites: Partial<Record<WeatherKey, ComponentType<any>>> = {};
  (Object.keys(urls) as WeatherKey[]).forEach((key) => {
    weatherSprites[key] = wrapFromUrl(urls[key]);
  });

  return {
    weatherSprites,
    spriteUrls: urls,
  };
}

// ----------------------------------------------------
// Sprite URL maps per island
// ----------------------------------------------------

const amisSpriteUrls: Record<WeatherKey, string> = {
  neutre: AmisNeutreUrl,
  nuit: AmisNuitUrl,
  soleil: AmisSoleilUrl,
  nuage: AmisNuageUrl,
  couvert: AmisCouvertUrl,
  pluie: AmisPluieUrl,
  orage: AmisOrageUrl,
};

const familleSpriteUrls: Record<WeatherKey, string> = {
  neutre: FamilleNeutreUrl,
  nuit: FamilleNuitUrl,
  soleil: FamilleSoleilUrl,
  nuage: FamilleNuageUrl,
  couvert: FamilleCouvertUrl,
  pluie: FamillePluieUrl,
  orage: FamilleOrageUrl,
};

const amourSpriteUrls: Record<WeatherKey, string> = {
  neutre: AmourNeutreUrl,
  nuit: AmourNuitUrl,
  soleil: AmourSoleilUrl,
  nuage: AmourNuageUrl,
  couvert: AmourCouvertUrl,
  pluie: AmourPluieUrl,
  orage: AmourOrageUrl,
};

const ecransSpriteUrls: Record<WeatherKey, string> = {
  neutre: EcransNeutreUrl,
  nuit: EcransNuitUrl,
  soleil: EcransSoleilUrl,
  nuage: EcransNuageUrl,
  couvert: EcransCouvertUrl,
  pluie: EcransPluieUrl,
  orage: EcransOrageUrl,
};

const loisirsSpriteUrls: Record<WeatherKey, string> = {
  neutre: LoisirsNeutreUrl,
  nuit: LoisirsNuitUrl,
  soleil: LoisirsSoleilUrl,
  nuage: LoisirsNuageUrl,
  couvert: LoisirsCouvertUrl,
  pluie: LoisirsPluieUrl,
  orage: LoisirsOrageUrl,
};

const moiSpriteUrls: Record<WeatherKey, string> = {
  neutre: moiNeutreUrl,
  nuit: moiNuitUrl,
  soleil: moiSoleilUrl,
  nuage: moiCouvertUrl,
  couvert: moiNuageUrl,
  pluie: moiPluieUrl,
  orage: moiOrageUrl,
};

// (Etudes sprites ready if you later add that island)
const etudesSpriteUrls: Record<WeatherKey, string> = {
  neutre: EtudesNeutreUrl,
  nuit: EtudesNuitUrl,
  soleil: EtudesSoleilUrl,
  nuage: EtudesNuageUrl,
  couvert: EtudesCouvertUrl,
  pluie: EtudesPluieUrl,
  orage: EtudesOrageUrl,
};

// (Etudes sprites ready if you later add that island)
const weatherSpriteUrls: Record<WeatherKey, string> = {
  neutre: moiNeutreUrl,
  nuit: moiNuitUrl,
  soleil: WeatherSoleilUrl,
  nuage: WeatherNuageUrl,
  couvert: WeatherCouvertUrl,
  pluie: WeatherPluieUrl,
  orage: WeatherOrageUrl,
};

// ----------------------------------------------------
// Shared scales
// ----------------------------------------------------

const likertSpriteScale: ScaleDef = {
  min: 0,
  max: 10,
  mode: "sprite",
  map: (score: number): WeatherKey => {
    if (score >= 8) return "soleil";
    if (score >= 6) return "couvert";
    if (score >= 4) return "nuage";
    if (score >= 2) return "pluie";
    return "orage";
  },
};
const likertEmojiScale: ScaleDef = {
  min: 0,
  max: 10,
  mode: "emoji",
  map: (score: number) => {
    if (score >= 8) return "☀️";
    if (score >= 6) return "⛅";
    if (score >= 4) return "☁️";
    if (score >= 2) return "🌧️";
    return "⛈️";
  },
};

const likertWSpriteScale: ScaleDef = {
  min: 0,
  max: 10,
  mode: "sprite",
  map: (score: number): WeatherKey => {
    if (score >= 8) return "soleil";
    if (score >= 6) return "couvert";
    if (score >= 4) return "nuage";
    if (score >= 2) return "pluie";
    return "orage";
  },
};
// ----------------------------------------------------
// Island registry
// ----------------------------------------------------

export const ISLAND_REGISTRY: Record<string, IslandDef> = {
  amis: {
    key: "amis",
    title: "Amis",
    NightComponent: wrapFromUrl(AmisNuitUrl),
    NeutralComponent: wrapFromUrl(AmisNeutreUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 10,
      chartType: "circles", // numeric circles
    },

    inline: {
      sequenceId: 11,
      chartType: "sprites",
      scale: likertWSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(amisSpriteUrls),
    graphSpriteUrls: weatherSpriteUrls, // reuse shared weather sprites for graph page
  },

  famille: {
    key: "famille",
    title: "Famille",
    NightComponent: wrapFromUrl(FamilleNuitUrl),
    NeutralComponent: wrapFromUrl(FamilleNeutreUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 8,
      chartType: "circles",
    },

    inline: {
      sequenceId: 9,
      chartType: "sprites",
      scale: likertWSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(familleSpriteUrls),
    graphSpriteUrls: weatherSpriteUrls, 
  },

  amour: {
    key: "amour",
    title: "Amour",
    NightComponent: wrapFromUrl(AmourNuitUrl),
    NeutralComponent: wrapFromUrl(AmourNeutreUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 14,
      chartType: "circles",
    },

    inline: {
      sequenceId: 15,
      chartType: "sprites",
      scale: likertWSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(amourSpriteUrls),
    graphSpriteUrls: weatherSpriteUrls, 
  },

  ecrans: {
    key: "ecrans",
    title: "Écrans",
    NightComponent: wrapFromUrl(EcransNuitUrl),
    NeutralComponent: wrapFromUrl(EcransNeutreUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 6,
      chartType: "circles",
    },

    inline: {
      sequenceId: 7,
      chartType: "sprites",
      scale: likertWSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(ecransSpriteUrls),
    graphSpriteUrls: weatherSpriteUrls, 
  },

  loisirs: {
    key: "loisirs",
    title: "Loisirs",
    NightComponent: wrapFromUrl(LoisirsNuitUrl),
    NeutralComponent: wrapFromUrl(LoisirsNeutreUrl),
    dx: 10,
    dy: 90,

    main: {
      sequenceId: 16,
      chartType: "circles",
    },

    inline: {
      sequenceId: 17,
      chartType: "sprites",
      scale: likertWSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(loisirsSpriteUrls),
    graphSpriteUrls: weatherSpriteUrls, 
  },

  moi: {
    key: "moi",
    title: "Moi",
    NightComponent: wrapFromUrl(moiNuitUrl),
    NeutralComponent: wrapFromUrl(moiNeutreUrl),
    iconWidth: "140px",

    // main sequence uses emojis
    main: {
      sequenceId: 12,
      chartType: "emojis",
      scale: {
        min: 0,
        max: 15,
        mode: "emoji",
        map: (score: number) => {
          if (score >= 12) return "😄";
          if (score >= 9) return "🙂";
          if (score >= 6) return "😐";
          if (score >= 3) return "☹️";
          return "😢";
        },
      },
    },

    // inline sequence drives sprites (same Likert scale)
    inline: {
      sequenceId: 13,
      chartType: "sprites",
      scale: likertSpriteScale,
      islandScale: likertSpriteScale,
    },

    iconFromInline: true,
    ...makeSpriteSet(moiSpriteUrls),
  },
};

// ----------------------------------------------------
// Derived convenience structures
// ----------------------------------------------------

export const ISLANDS = {
  top: ["famille", "amis"].map((k) => ISLAND_REGISTRY[k]),
  bottom: ["amour", "ecrans", "loisirs"].map((k) => ISLAND_REGISTRY[k]),
  center: ISLAND_REGISTRY.moi,
};

export const SUBISLANDS: Record<string, IslandDef[]> = Object.fromEntries(
  Object.entries(ISLAND_REGISTRY)
    .filter(([_, v]) => v.subs?.length)
    .map(([k, v]) => [k, v.subs!])
);

export const TITLE_MAP = Object.fromEntries(
  Object.entries(ISLAND_REGISTRY).flatMap(([k, v]) => [
    [k, v.title],
    ...(v.subs?.map((s) => [s.key, s.title]) ?? []),
  ])
);

export const SEQUENCE_MAP = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => {
    const pairs: [string, number][] = [];
    if (parent.main.sequenceId) {
      pairs.push([parent.key, parent.main.sequenceId]);
    }
    parent.subs?.forEach((s) => {
      if (s.main.sequenceId) {
        pairs.push([s.key, s.main.sequenceId]);
      }
    });
    return pairs;
  })
);

// inline sequences
export const INLINE_SEQUENCE_MAP = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => {
    const pairs: [string, number][] = [];
    if (parent.inline?.sequenceId) {
      pairs.push([parent.key, parent.inline.sequenceId]);
    }
    parent.subs?.forEach((s) => {
      if (s.inline?.sequenceId) {
        pairs.push([s.key, s.inline.sequenceId]);
      }
    });
    return pairs;
  })
);

// used by EvolutionChart / EvolutionCalendar
export interface SequenceRenderCfg {
  chartType: "circles" | "emojis" | "sprites";
  scale?: ScaleDef;
  spriteUrls?: Partial<Record<WeatherKey, string>>; // "soleil", "pluie", ...
}

export const SEQUENCE_RENDER_MAP: Record<number, SequenceRenderCfg> =
  Object.fromEntries(
    Object.values(ISLAND_REGISTRY)
      .flatMap((island) => [island, ...(island.subs ?? [])])
      .flatMap((island) => {
        const entries: { id: number; cfg: SequenceRenderCfg }[] = [];

        const addCfg = (seqCfg?: SequenceVisualConfig) => {
          if (!seqCfg?.sequenceId) return;
          entries.push({
            id: seqCfg.sequenceId,
            cfg: {
              chartType: seqCfg.chartType ?? "circles",
              scale: seqCfg.scale,
              // same island spriteUrls for both main & inline sequences
              // ✅ graph sprite set if provided, otherwise fallback to island set
              spriteUrls: island.graphSpriteUrls ?? island.spriteUrls,
            },
          });
        };

        addCfg(island.main);
        addCfg(island.inline);

        return entries;
      })
      .map(({ id, cfg }) => [id, cfg] as const)
  );

// Flat map: key -> IslandDef for both islands and subislands
export const ALL_ISLANDS: Record<string, IslandDef> = Object.fromEntries(
  Object.values(ISLAND_REGISTRY).flatMap((parent) => [
    [parent.key, parent],
    ...(parent.subs?.map((s) => [s.key, s]) ?? []),
  ])
);
